import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { Repeat } from 'lucide-react';
import AutoInvoiceDetails from './components/AutoInvoiceDetails';
import InvoiceItems from '../invoice-form/components/InvoiceItems';
import AutoInvoiceActions from './components/AutoInvoiceActions';

const NewAutomaticInvoiceForm = ({
  items = [],
  formData = {},
  bankDetails = [],
  addItemDiv = () => {},
  removeItemDiv = () => {},
  handleInputChange = () => {},
  handleItemInputChange = () => {},
  handleRecurringInvoiceSubmit = () => {},
  searchClients = () => {},
  suggestions = [],
  showSuggestions = false,
  clearSuggestions = () => {}
}) => {
  return (
    <div className="w-full">
      <Tile>
        <TileHeader title="Нова автоматична фактура" icon={Repeat} />
        <AutoInvoiceDetails 
          formData={formData}
          handleInputChange={handleInputChange}
          bankDetails={bankDetails}
          searchClients={searchClients}
          suggestions={suggestions}
          showSuggestions={showSuggestions}
          clearSuggestions={clearSuggestions}
        />
        <InvoiceItems 
          items={items}
          handleItemInputChange={handleItemInputChange}
          addItemDiv={addItemDiv}
          removeItemDiv={removeItemDiv}
        />
        <AutoInvoiceActions 
          handleInvoiceSubmit={handleRecurringInvoiceSubmit}
        />
      </Tile>
    </div>
  );
};

export default NewAutomaticInvoiceForm;
